module.exports = __webpack_public_path__ + "img/ajuda.99626ca4.svg";